import store from '../store'

export default (to, from, next) => {
  if (to.matched.some(record => record.meta.step)) {
    if (to.meta.step > 2 && store.getters.skipOrder !== null && store.getters.skipOrder) {
      store.commit('setStep', to.meta.step - 1)
    } else {
      store.commit('setStep', to.meta.step)
    }
    next()
  }
}
